import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./login_reg.css";
import toastError from "_hooks/toast";
import { resetPassword } from "_services/userApi";
import LoadingOverlay from "_components/overlay/LoadingOverlay";

export { ResetPassword };

function ResetPassword() {
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [validation, setValidation] = useState({
    length: false,
    uppercaseLowercase: false,
    number: false,
    specialCharacter: false,
    passwordsMatch: false,
  });
  const [token, setToken] = useState("");
  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromURL = queryParams.get("token");
    if (tokenFromURL) {
      setToken(tokenFromURL);
    } else {
      toastError("Token not found!");
    }
  }, [location]);

  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);

    setValidation({
      length: password.length >= 8,
      uppercaseLowercase: /[a-z]/.test(password) && /[A-Z]/.test(password),
      number: /\d/.test(password),
      specialCharacter: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      passwordsMatch: password === confirmPassword,
    });
  };

  const handleConfirmPasswordChange = (e) => {
    const confirm = e.target.value;
    setConfirmPassword(confirm);

    setValidation((prev) => ({
      ...prev,
      passwordsMatch: newPassword === confirm,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const allValid = Object.values(validation).every((isValid) => isValid);
    if (!allValid) return;
    if (token.length < 1) {
      toastError("Token not found!");
      return;
    }

    setLoader(true);
    const resp = await resetPassword(token,newPassword);
    if (resp?.success) {
      setSuccess(true);
    }
    setLoader(false);
  };

  return (
    <section className="login-sec d-flex align-center justify-center relative">
      <div className="login-body relative">
        <div className="l-logo relative">
          <img src="/images/login-logo.svg" alt="" />
        </div>
        {!success ? (
          <div className="login-box relative d-flex flex-col justify-between">
            <h5 className="d-flex justify-center mb-3">Reset your Password</h5>
            <p className="text-center mb-1">
              Please confirm the registered email address to send the password
              reset link
            </p>
            <form className="relative" onSubmit={handleSubmit}>
              <div className="form-group relative d-flex flex-col-reverse">
                <input
                  name="newPassword"
                  type={showNewPassword ? "text" : "password"}
                  className="form-control"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                />
                <label className="relative d-flex justify-between align-center">
                  New Password
                </label>
                <span
                  className="material-symbols-outlined"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    cursor: "pointer",
                    fontSize: "24px",
                  }}
                >
                  {showNewPassword ? "visibility_off" : "visibility"}
                </span>
              </div>

              <span
                className={`d-flex align-center gap-1 mt-1 ${validation.length ? "success" : "error"}`}
              >
                <span className="material-symbols-outlined">
                  {validation.length ? "check_circle" : "info"}
                </span>{" "}
                Must contain at least 8 characters
              </span>
              <span
                className={`d-flex align-center gap-1 mt-1 ${validation.uppercaseLowercase ? "success" : "error"}`}
              >
                <span className="material-symbols-outlined">
                  {validation.uppercaseLowercase ? "check_circle" : "info"}
                </span>{" "}
                Must contain an uppercase and a lowercase (A, z)
              </span>
              <span
                className={`d-flex align-center gap-1 mt-1 ${validation.number ? "success" : "error"}`}
              >
                <span className="material-symbols-outlined">
                  {validation.number ? "check_circle" : "info"}
                </span>{" "}
                Must contain a number
              </span>
              <span
                className={`d-flex align-center gap-1 mt-1 ${validation.specialCharacter ? "success" : "error"}`}
              >
                <span className="material-symbols-outlined">
                  {validation.specialCharacter ? "check_circle" : "info"}
                </span>{" "}
                Must contain a special character (!, %, @, # etc.)
              </span>

              <div className="form-group relative d-flex flex-col-reverse">
                <input
                  name="confirmPassword"
                  type="password"
                  className="form-control"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                <label className="relative d-flex justify-between align-center">
                  Confirm Password
                </label>
              </div>
              <span
                className={`d-flex align-center gap-1 mt-1 ${validation.passwordsMatch ? "success" : "error"}`}
              >
                <span className="material-symbols-outlined">
                  {validation.passwordsMatch ? "check_circle" : "info"}
                </span>{" "}
                {validation.passwordsMatch
                  ? "Password is matching "
                  : "Password is not matching"}
              </span>

              <div className="form-btn-part relative d-flex flex-col">
                <button
                  type="submit"
                  className="btns login-form-btn"
                  disabled={
                    !Object.values(validation).every((isValid) => isValid)
                  }
                >
                  Reset Password
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="login-box relative d-flex flex-col justify-center align-items-center">
            <p className="text-center mb-4">
              {" "}
              Success! Your password has been reset.
            </p>
            <div className="form-btn-part relative d-flex flex-col">
              <button
                className="btns login-success-btn"
                onClick={() => navigate("/account/login")}
              >
                Back to Login
              </button>
            </div>
          </div>
        )}
      </div>
            {loader && <LoadingOverlay/>}
    </section>
  );
}
